import Auth from '../../api/autorizationApi';
import Router from '@/router/index';

export default {
  state: {
    claims: [],
    userClaim: []
  },
  mutations: {
    AUTH_FETCH_Claims(state, data) {
      state.claims = data;
    },
    AUTH_FETCH_CLAIMS_USER(state, data) {
      state.userClaim = data;
    }
  },
  actions: {
    AUTH_FETCH_TOKEN() {
      if(window.$cookies.isKey('auth')) {
        return Promise.resolve(window.$cookies.get("auth"));
      }

      return Promise.reject("Cannot get auth token");
    },
    AUTH_FETCH_CLAIMS(store) {
      Auth.fetchClaims().then(result => {
        store.commit('AUTH_FETCH_Claims', result);
      }).catch(() => {

      });
    },
    AUTH_FETCH_CLAIMS_USER(store, data) {
      Auth.fetchUserClaims(data).then(result => {
        store.commit('AUTH_FETCH_Claims', result.data);
      }).catch(() => {

      });
    },
    AUTH_FETCH_CLAIMS_ROLE(store, data) {
      Auth.fetchRoleClaims(data).then(result => {
        store.commit('AUTH_FETCH_Claims', result.data);
      }).catch(() => {

      });
    },
    AUTH_UPDATE_CLAIMS(store, data) {
      Auth.updateClaims(data.email,  data.claims).then(() => {

      }).catch(() => {

      });
    },
    AUTH_UPDATE_ROLES(store, data) {
      Auth.updateRoles(data.email,  data.roles).then(() => {

      }).catch(() => {

      });
    },
    AUTH_LOGIN(store, data) {
      Auth.login(data.email, data.password).then(response => {
        const token = response.data.access_token;
        if(window.$cookies.isKey('auth'))
          window.$cookies.remove('auth');

        window.$cookies.set('auth', token);

        if(data.callBack !== undefined)
            data.callBack();
      }).catch(() => {
        store.dispatch('NOTIFY_ERROR', "Fehlerhafte Logindaten");
        if(data.errorCallBack !== undefined)
          data.errorCallBack();
      })
    },
    async AUTH_ISAUTHENTICATED() {
      const authExist = window.$cookies.isKey('auth');
      let toLogin = false;
      if(!authExist) {
        toLogin = true;
      }
      else
        toLogin = !(await Auth.isAuth()).data;

      if(toLogin)
        await Router.push({name: 'Forbidden'});
    },
    AUTH_LOGOUT() {
      if(window.$cookies.isKey('auth'))
        window.$cookies.remove('auth');
    },
    async AUTH_URL(_, form) {
      try {
        const response = await Auth.authUrl(form);
        return Promise.resolve(response.data);
      } catch(error) {
        return await Promise.reject(error);
      }
    }
  }
}
